import {FormikErrors} from 'formik';
import {set} from 'lodash-es';
import {builderFieldsType} from '../CreateBuilder/builderFields';
import {BUILDER_SUBTYPE_TO_SERVER} from '../constants/SolutionType';
import {cleanForCuro} from '../../../utils/cleanString';
import {
  getPotContactId,
  updateRecsVarsProps,
  upsertBuilderHeader,
} from './builderHelpers';
import validateUUID from '../../../utils/validateUUID';
import {SaltusAny} from '../../../utils/SaltusAny';
import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';

export const saveAction = async (props: updateRecsVarsProps): Promise<string> => {
  const {accountId, values} = props;
  const {contact, urgency, urgencyReason, action} = values;

  const ovrecommendId = await upsertBuilderHeader(props, {
    action: OVRecommendActionEnum.ACTION,
    solutionType: BUILDER_SUBTYPE_TO_SERVER.ACTION_BASED,
    accountId: validateUUID(accountId),
    goalId: validateUUID(values.goal?.id),
    contactId: getPotContactId(contact),
    urgency,
    urgencyReason,
    note: cleanForCuro(action?.note) || '',
  });

  await props.upsertBuilderAction({
    variables: {ovrecommendId: validateUUID(ovrecommendId)!},
  });

  return ovrecommendId;
};

export const actionValidator = (
  values: builderFieldsType,
  errors: SaltusAny
): FormikErrors<builderFieldsType> => {
  if (!values.goal?.id) {
    if (!values.isSppDa) {
      errors.goal = 'Please select a goal';
    }
  }
  if (!values.action?.note) {
    set(errors, 'action.note', 'A note is required');
  }
  return errors;
};
